firebird.factory('presentationInvitationAPIService', [
    '$q',
    '$resource',
    'helperService',
    function ($q, $resource, helperService) {
        var endpoint = helperService.getAPIUrl() + '/presentationinvitation';

        var service = {
            getPresentationInvitationResultById: getPresentationInvitationResultById
        };

        return service;

        ////////////////////////

        function getPresentationInvitationResultById(params) {
            var deferred = $q.defer();

            var paramDefaults = {
                id: '@id'
            };

            $resource(endpoint + '/result/:id', paramDefaults)
                .get(params)
                .$promise.then(
                    function (presentationInvitationResult) {
                        deferred.resolve(presentationInvitationResult);
                    },
                    function (err) {
                        deferred.reject(err.status + ' - Could not retrieve presentation invitation result');
                    }
                );

            return deferred.promise;
        }
    }
]);
